var map = {
	"./bg-profile.jpg": 72722,
	"./bg-profile1.jpg": 64669,
	"./post1.jpg": 80884,
	"./post2.jpg": 10595,
	"./post3.jpg": 67462,
	"./post4.jpg": 86541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44435;